// ── LO QUE SE LE DICE A ALGUIEN CUANDO SU SESIÓN SE ACABA ───────────────────────────────────────
//
// EL TEXTO ANTERIOR NO SE ENTENDÍA, y lo dijo el dueño con todas las letras: «ni yo sabía a qué se
// refería». Decía «Tu sesión ha llegado a su límite. Guarda lo que tengas a medias: en cuanto caduque
// el acceso habrá que volver a entrar». Tres cosas mal en una frase:
//   · no dice POR QUÉ pasa (parece una avería, y es una medida de seguridad);
//   · no dice QUÉ HACER (¿esperar? ¿guardar y seguir? ¿salir?);
//   · habla en futuro —«en cuanto caduque»— cuando el momento YA ha llegado.
//
// LO QUE HAY DETRÁS, para que el texto no mienta: el token se cambia solo cada rato y quien trabaja
// no nota nada. Lo que NO se renueva es el techo de 7 días desde que se tecleó la contraseña
// (backend/services/sesionEquipo.js). Al llegar ahí, `/auth/renovar` contesta que no y hay que
// volver a entrar. No es un fallo ni un castigo: es lo que hace que un token robado del navegador
// no valga para siempre.
//
// Y POR QUÉ SALE UNA Y OTRA VEZ: el aviso se marca como «ya dado» en memoria, así que cada RECARGA
// de la página lo vuelve a armar. Quien está probando algo y recarga mucho lo ve repetido — no es
// que se dispare solo. Por eso el texto tiene que decir que la salida es salir y entrar, no esperar.
//
// Vive aquí, y no dentro del componente, para que una guardia pueda comprobar QUÉ dice: un texto
// metido en medio de un `useEffect` solo se puede mirar leyendo el fichero.

// `restanMin` es lo que contesta el servidor al renovar. Devuelve el aviso ya montado.
import { t } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export function avisoDeSesion(restanMin) {
  const min = Number(restanMin);
  // Todavía queda margen: se avisa para que nadie se quede a medias de escribir algo largo.
  if (Number.isFinite(min) && min > 0) {
    const horas = Math.max(1, Math.round(min / 60));
    return t('utils.avisoSesion.por_seguridad_hay_que_volver', 'Por seguridad hay que volver a escribir la contraseña cada 7 días, y a tu sesión le quedan menos de {{horas}} h. No tienes que hacer nada ahora: cuando termines lo que estés haciendo, cierra sesión y vuelve a entrar.', { horas });
  }
  // Ya se acabó: aquí no vale «guarda y sigue», porque la próxima petición al servidor te sacará.
  return t('utils.avisoSesion.por_seguridad_hay_que_volver_2', 'Por seguridad hay que volver a escribir la contraseña cada 7 días, y tu sesión ya ha llegado a ese punto. Guarda lo que tengas a medias y vuelve a entrar: hasta que no lo hagas, la aplicación puede cerrarse sola en cualquier momento.');
}
